import React from 'react';

export function EditorTemplateRenderer(props: { templates: JSX.Element[] }) {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
      <span style={{ alignSelf: 'start', lineHeight: '26px' }}>(</span>
      {props.templates.map((fieldWidget: JSX.Element, idx) => (
        <>
          {fieldWidget}
          {idx + 1 < props.templates.length ? (
            <span style={{ marginRight: '3px' }}>,</span>
          ) : null}
        </>
      ))}
      <span style={{ alignSelf: 'end', lineHeight: '26px' }}>)</span>
    </div>
  );
}
